module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "booking-summary__offers booking-summary-callout booking-summary-callout--info"
  }, [_c('strong', {
    staticClass: "callout-title"
  }, [_c('svg', {
    attrs: {
      "width": "25",
      "height": "30",
      "viewBox": "0 0 1792 1792"
    }
  }, [_c('path', {
    attrs: {
      "d": "M576 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zm1067 576q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"
    }
  })]), _vm._v(" "), _c('span', [_vm._v("Would you like to include an offer in your booking?")])]), _vm._v(" "), _c('div', {
    staticClass: "offer-selection"
  }, [_vm._l((_vm.offers), function(offer) {
    return _c('div', {
      key: offer.id,
      staticClass: "flex align-center inline-checkbox-outer"
    }, [_c('label', {
      staticClass: "input__inline-label"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedOffer),
        expression: "selectedOffer"
      }],
      attrs: {
        "type": "radio",
        "id": offer.id,
        "name": "offer"
      },
      domProps: {
        "value": offer.id,
        "checked": _vm._q(_vm.selectedOffer, offer.id)
      },
      on: {
        "change": function($event) {
          _vm.selectedOffer = offer.id
        }
      }
    }), _vm._v("\n          " + _vm._s(offer.name) + "\n        ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "flex align-center inline-checkbox-outer"
  }, [_c('label', {
    staticClass: "input__inline-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedOffer),
      expression: "selectedOffer"
    }],
    attrs: {
      "type": "radio",
      "id": null,
      "name": "offer"
    },
    domProps: {
      "value": null,
      "checked": _vm._q(_vm.selectedOffer, null)
    },
    on: {
      "change": function($event) {
        _vm.selectedOffer = null
      }
    }
  }), _vm._v("\n          No thanks\n        ")])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-065935c4","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/offersInput.vue
// module id = 580
// module chunks = 0